/**
 * Check if the date is valid for example, 1990/02/30 is invalid and 1990/02/28 is valid.
 */
window.isValidDate = (year, month, day) => {
  const date = new Date(year, month - 1, day);

  return !isNaN(date) && date.getFullYear() === +year && date.getMonth() === +month - 1 && date.getDate() === +day;
};

/**
 * Check if the date is before today, it must be 1 day of difference between date and today variables to be valid.
 */
window.isBeforeToday = (year, month, day) => {
  const date = new Date(year, month - 1, day);
  const today = new Date();

  return Math.floor((today - date) / (1000 * 60 * 60 * 24)) >= 1;
};
